/* product-showcase.js — rail click → hero stage swap + in-stage image scrub */
(function () {
  'use strict';

  const imageLoads = new WeakMap();

  function loadDemandImage(img) {
    if (!img || img.tagName !== 'IMG') return Promise.resolve(true);
    if (imageLoads.has(img)) return imageLoads.get(img);
    const promise = new Promise((resolve) => {
      let settled = false;
      const finish = (ok) => {
        if (settled) return;
        settled = true;
        clearTimeout(timeout);
        img.removeEventListener('load', loaded);
        img.removeEventListener('error', failed);
        resolve(ok);
      };
      const loaded = () => {
        if (img.decode) img.decode().then(() => finish(true), () => finish(img.naturalWidth > 0));
        else finish(img.naturalWidth > 0);
      };
      const failed = () => finish(false);
      const timeout = setTimeout(() => finish(false), 15000);
      img.addEventListener('load', loaded);
      img.addEventListener('error', failed);
      img.loading = 'eager';
      const picture = img.closest('picture');
      if (picture) picture.querySelectorAll('source[data-demand-srcset]').forEach((source) => {
        source.srcset = source.dataset.demandSrcset;
      });
      if (img.dataset.demandSrcset) img.srcset = img.dataset.demandSrcset;
      if (img.dataset.demandSrc) img.src = img.dataset.demandSrc;
      if (img.complete && img.naturalWidth > 0) loaded();
    });
    imageLoads.set(img, promise);
    promise.then(() => imageLoads.delete(img));
    return promise;
  }

  document.querySelectorAll('[data-ps-section]').forEach(initShowcase);

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-ps-section]').forEach(initShowcase);
  });

  function initShowcase(section) {
    if (section.dataset.psInitialized) return;
    section.dataset.psInitialized = 'true';
    var stages     = section.querySelectorAll('.ps-product-stage');
    var railRows   = section.querySelectorAll('.ps-rail__row');
    var counter    = section.querySelector('.ps-hint__counter');
    var total      = stages.length;
    var activeIdx  = 0;
    var navigation = 0;

    if (!stages.length || !railRows.length) return;

    /* ── Image switcher within a single stage group ─────────────────── */
    async function setStageImg(stage, imgIdx) {
      var request = ++navigation;
      var imgs   = stage.querySelectorAll('.ps-stage__img');
      var thumbs = stage.querySelectorAll('.ps-stage__thumb');
      var ready = await loadDemandImage(imgs[imgIdx]);
      if (!ready || request !== navigation || !section.isConnected) return;
      imgs.forEach(function (img, i)     { img.classList.toggle('is-active',   i === imgIdx); });
      thumbs.forEach(function (t, i)     { t.classList.toggle('is-active',     i === imgIdx); });
    }

    /* Attach thumb click handlers to every stage's thumbnail strip */
    stages.forEach(function (stage) {
      stage.querySelectorAll('.ps-stage__thumb').forEach(function (thumb, ti) {
        thumb.addEventListener('click', function (e) {
          e.stopPropagation();
          setStageImg(stage, ti);
        });
      });
    });

    /* ── Product switcher ────────────────────────────────────────────── */
    async function switchTo(idx) {
      var request = ++navigation;
      if (idx === activeIdx) return;
      var stage = stages[idx];
      if (!stage) return;
      var ready = await loadDemandImage(stage.querySelector('.ps-stage__img'));
      if (!ready || request !== navigation || !section.isConnected) return;
      stage.querySelectorAll('.ps-stage__thumb img[data-demand-src]').forEach(loadDemandImage);
      stage.querySelectorAll('.ps-stage__img').forEach(function (img, i) { img.classList.toggle('is-active', i === 0); });
      stage.querySelectorAll('.ps-stage__thumb').forEach(function (thumb, i) { thumb.classList.toggle('is-active', i === 0); });

      stages[activeIdx].classList.remove('is-active');
      railRows[activeIdx].classList.remove('is-active');

      activeIdx = idx;

      stages[activeIdx].classList.add('is-active');
      railRows[activeIdx].classList.add('is-active');

      /* Update counter */
      if (counter) counter.textContent = (activeIdx + 1) + ' of ' + total;

      /* Scroll the newly active row into view inside the rail */
      railRows[activeIdx].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    railRows.forEach(function (row, i) {
      row.addEventListener('click', function () { switchTo(i); });
    });

    /* Initialise counter text */
    if (counter) counter.textContent = '1 of ' + total;
  }
})();
